// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__1xy_S","buttons":"App_buttons__10DNt"};